import { __rest } from "tslib";
import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../lib/utils";
const TooltipProvider = TooltipPrimitive.Provider;
/**
 * @example
 *
 * ```jsx
 * import {
 *   Button,
 *   Tooltip,
 *   TooltipContent,
 *   TooltipProvider,
 *   TooltipTrigger,
 * } from "@skve/components"
 *
 * function Demo() {
 *   return (
 *     <TooltipProvider>
 *       <Tooltip>
 *         <TooltipTrigger asChild>
 *           <Button variant="outline">Hover</Button>
 *         </TooltipTrigger>
 *         <TooltipContent>
 *           <p>Add to library</p>
 *         </TooltipContent>
 *       </Tooltip>
 *     </TooltipProvider>
 *   )
 * }
 * ```
 */
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = React.forwardRef((_a, ref) => {
    var { className, sideOffset = 4 } = _a, props = __rest(_a, ["className", "sideOffset"]);
    return (React.createElement(TooltipPrimitive.Content, Object.assign({ ref: ref, sideOffset: sideOffset, className: cn("z-[500] overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2", className) }, props)));
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
//# sourceMappingURL=tooltip.js.map